import CryptoJS from 'crypto-js';
const secretKey = 'U8shqKMO75WY5ug83HMyLZjG';
export function getEncrypted(body) {
  const {
    enc: { Utf8 },
    mode: { ECB },
    pad: { Pkcs7 },
    TripleDES: { encrypt },
  } = CryptoJS;
  const key = Utf8.parse(secretKey);
  const config = { mode: ECB, padding: Pkcs7 };
  const utf8Parse = Utf8.parse(JSON.stringify(body));
  const encrypted = encrypt(utf8Parse, key, config).toString();
  const result = encrypted
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
  return result;
}
export const allFuntions = [
  {
    appId: 'jstec-jsjlr-zcg',
    title: '找成果',
    desc: '有技术需求、投资需求等，寻找科技成果',
    icon: require('@/assets/images/online-service/7.png'),
    template:
      '成果的技术领域分类是：<input id="goods" class="xxx" placeholder="技术领域" type="text" />；需要解决的问题：<input id="demand" class="xxx" placeholder="应用场景" type="text"/>；技术方案要求：<input id="plan" class="xxx" placeholder="技术要求" type="text"/>；请推荐合适的成果。',
  },
  {
    appId: 'jstec-jsjlr-zxq',
    title: '找需求',
    desc: '有科技成果、有专利，寻找技术需求合作',
    icon: require('@/assets/images/online-service/8.png'),
    template:
      '我想找相关需求，需求的技术领域分类是：<input id="technology" class="xxx" placeholder="技术领域" type="text"/>；可以提供的解决的方案：<input id="planDesc" class="xxx" placeholder="解决方案描述" type="text"/>；请推荐合适的需求。',
  },
  {
    appId: 'jstec-jsjlr-zfwjg',
    title: '找服务机构',
    desc: '有需求、科技成果，找专业服务机构',
    icon: require('@/assets/images/online-service/10.png'),
    template:
      '我想找相关服务机构，需求是：<input id="demand" class="xxx" placeholder="需求描述" type="text"/>；请推荐合适的服务机构',
  },
  {
    appId: 'jstec-jsjlr-zjsjlr',
    title: '找技术经理人',
    desc: '有需求、科技成果，找技术经理人及团队',
    icon: require('@/assets/images/online-service/9.png'),
    template:
      '我想找相关技术经理人，需求是：<input id="demand" class="xxx" placeholder="需求描述" type="text"/>；请推荐合适的技术经理人。',
  },
  {
    appId: 'jstec-jsjlr-zjgpg',
    title: '成果估价',
    desc: '有技术需求、科技成果，需要价格评估',
    icon: require('@/assets/images/online-service/12.png'),
    template: undefined,
  },
];
